// extracted by css-extract-rspack-plugin
export default {"seo-data":"N383bH","seoData":"N383bH"};